import React, { useState, useEffect } from "react";
import { collection, doc, getDoc, getDocs, updateDoc, deleteDoc } from "firebase/firestore";
import { db } from './../../firebase/firebaseConfig';
import { Navigate, useParams, useNavigate, Link } from "react-router-dom"; // Assuming you are using react-router-dom for routing
import Layout from "./Layout";
import PageTitle from "../includes/PageTitle";
import './../css/AdminForms.css';
/*
if (!product) {
  return <div>Loading...</div>;
}*/
const EditProduct = () => {
  const { id } = useParams(); // Get the product ID from the URL
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    price: "",
    sizes: [],
    colors: [],
    productDetails: "",
    category: "",
    subCategory: "",
    gender: "",
    collection: "",
    season: "",
    images: [],
    modelName: "",
    modelHeight: "",
    chest: "",
    waist: "",
    materials: [""],
    quantity: 1, // Add quantity field
    type: "" // Add type field
  });

  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [genders, setGenders] = useState([]);
  const [collections, setCollections] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [allSizes, setAllSizes] = useState([]);
  const [allColors, setAllColors] = useState([]);

  useEffect(() => {
    const fetchProductData = async () => {
        try {
          const productDoc = await getDoc(doc(db, "Products", id));
          if (productDoc.exists()) {
            const productData = productDoc.data();
            setFormData(productData);
          } else {
            navigate("/404")
          }
        } catch (error) {
          console.error("Error fetching product data: ", error);
        }
      };

    const fetchMetaData = async () => {
      try {
        const [
          categoriesSnapshot,
          subCategoriesSnapshot,
          gendersSnapshot,
          collectionsSnapshot,
          seasonsSnapshot,
          sizesSnapshot,
          colorsSnapshot
        ] = await Promise.all([
          getDocs(collection(db, "Categories")),
          getDocs(collection(db, "sub_category")),
          getDocs(collection(db, "gender")),
          getDocs(collection(db, "Collections")),
          getDocs(collection(db, "Seasons")),
          getDocs(collection(db, "Sizes")),
          getDocs(collection(db, "Colors"))
        ]);

        const fetchedCategories = categoriesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        const fetchedSubCategories = subCategoriesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        const fetchedGenders = gendersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        const fetchedCollections = collectionsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        const fetchedSeasons = seasonsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        const fetchedSizes = sizesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        const fetchedColors = colorsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        setCategories(fetchedCategories);
        setSubCategories(fetchedSubCategories);
        setGenders(fetchedGenders);
        setCollections(fetchedCollections);
        setSeasons(fetchedSeasons);
        setAllSizes(fetchedSizes);
        setAllColors(fetchedColors);
      } catch (error) {
        console.error("Error fetching meta data: ", error);
      }
    };

    fetchProductData();
    fetchMetaData();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
  };
  const handleCheckboxChange = (e, field) => {
    const { value, checked } = e.target;
    setFormData(prevState => {
      const newValue = checked 
        ? [...prevState[field], value] 
        : prevState[field].filter(item => item !== value);
      return { ...prevState, [field]: newValue };
    });
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setFormData(prevState => ({ ...prevState, images: [...prevState.images, ...files] }));
  };

  const handleImageRemove = (index) => {
    setFormData(prevState => {
      const newImages = prevState.images.filter((_, i) => i !== index);
      return { ...prevState, images: newImages };
    });
  };
  const handleMaterialChange = (e, index) => {
    const newMaterials = [...formData.materials];
    newMaterials[index] = e.target.value;
    setFormData(prevState => ({ ...prevState, materials: newMaterials }));
  };

  const addMaterial = () => {
    setFormData(prevState => ({ ...prevState, materials: [...prevState.materials, ""] }));
  };

  const removeMaterial = (index) => {
    setFormData(prevState => ({ 
      ...prevState, 
      materials: prevState.materials.filter((_, i) => i !== index) 
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const updatedProduct = {
        ...formData,
        images: formData.images.map(img => (typeof img === 'string' ? img : URL.createObjectURL(img)))
      };
      await updateDoc(doc(db, "Products", id), updatedProduct);
      alert("Product updated successfully!");
    } catch (error) {
      console.error("Error updating product: ", error);
      alert("Error updating product.");
    }
  };

  // Filter subCategories based on selected category
  const filteredSubCategories = subCategories.filter(subCat => subCat.category === formData.category);

  const handleDelete = async () => {
    try {
      const productRef = doc(db, "Products", id); // Use 'id' instead of 'productId'
      await deleteDoc(productRef);
      alert("Product deleted successfully!");
      // Redirect or update UI after deletion
      navigate("/a/dashboard");
    } catch (error) {
      // Check if the error is because the document does not exist
      if (error.code === 'not-found') {
        // Redirect to "/404"
        navigate("/404");
      } else {
        console.error("Error deleting product: ", error);
        alert("Error deleting product.");
      }
      alert("Error deleting product.");
    }
  };
  

  return (
    <>
      <PageTitle title="Edit Product - ALMOSTINVISIBLE" />
      <Layout>
        <div className="mt-5">
          <h1 className="unbounded">Edit Product</h1>
          <hr />
          <div className="d-flex justify-content-around">
            <button type="button" onClick={handleDelete} className="red-button">Delete Product</button>
            <Link to={`/p/${id}`} className="white-button">View on main site</Link>
          </div>
<br />
          <form onSubmit={handleSubmit} className="form-admin">
            {/* Product Name */}
            <div className="form-group">
              <label>Name*</label>
              <input
                type="text"
                className="inputForm"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Enter product name"
              />
            </div>

            {/* Price */}
            <div className="form-group">
              <label>Price*</label>
              <input
                type="number"
                className="inputForm"
                name="price"
                value={formData.price}
                onChange={handleChange}
                required
                placeholder="Enter product price"
              />
            </div>

            {/* Sizes */}
            <div className="form-group">
              <label>Sizes*</label>
              <div>
                {allSizes.map(size => (
                  <div key={size.id} className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="sizes"
                      value={size.name}
                      checked={formData.sizes.includes(size.name)}
                      onChange={(e) => handleCheckboxChange(e, "sizes")}
                    />
                    <label className="form-check-label">{size.name}</label>
                  </div>
                ))}
              </div>
            </div>
            <br />

            {/* Colors */}
            <div className="form-group">
              <label>Colors*</label>
              <div>
                {allColors.map(color => (
                  <div key={color.id} className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="colors"
                      value={color.name}
                      checked={formData.colors.includes(color.name)}
                      onChange={(e) => handleCheckboxChange(e, "colors")}
                    />
                    <span
                      className="color-circle"
                      style={{ backgroundColor: color.color }}
                    ></span>
                    <label className="form-check-label">{color.name}</label>
                  </div>
                ))}
              </div>
            </div>
            <br />

            {/* Product Details */}
            <div className="form-group">
              <label>Product Details*</label>
              <textarea
                className="inputForm"
                name="productDetails"
                value={formData.productDetails}
                onChange={handleChange}
                required
                placeholder="Enter product details"
                rows="50"
                style={{resize: "none", height: "40vh", padding: "2vh 2vw"}}
                
              />
            </div>

            {/* Category */}
            <div className="form-group">
              <label>Category*</label>
              <select
                name="category"
                value={formData.category}
                onChange={handleChange}
                className="inputForm"
                required
              >
                <option value="">Select Category</option>
                {categories.map(cat => (
                  <option key={cat.id} value={cat.id}>{cat.name}</option>
                ))}
              </select>
            </div>

            {/* Sub-Category */}
            <div className="form-group">
              <label>Sub-Category*</label>
              <select
                name="subCategory"
                value={formData.subCategory}
                onChange={handleChange}
                className="inputForm"
                required
              >
                <option value="">Select Sub-Category</option>
                {filteredSubCategories.map(subCat => (
                  <option key={subCat.id} value={subCat.id}>{subCat.sub_category_name}</option>
                ))}
              </select>
            </div>

            {/* Gender */}
            <div className="form-group">
              <label>Gender*</label>
              <select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                className="inputForm"
                required
              >
                <option value="">Select Gender</option>
                {genders.map(gen => (
                  <option key={gen.id} value={gen.id}>{gen.gender_name}</option>
                ))}
              </select>
            </div>

            {/* Collection */}
            <div className="form-group">
              <label>Collection</label>
              <select
                name="collection"
                value={formData.collection}
                onChange={handleChange}
                className="inputForm"
              >
                <option value="">Select Collection</option>
                {collections.map(col => (
                  <option key={col.id} value={col.id}>{col.collection_name}</option>
                ))}
              </select>
            </div>

            {/* Season */}
            <div className="form-group">
              <label>Season</label>
              <select
                name="season"
                value={formData.season}
                onChange={handleChange}
                className="inputForm"
              >
                <option value="">Select Season</option>
                {seasons.map(season => (
                  <option key={season.id} value={season.id}>{season.season_name}</option>
                ))}
              </select>
            </div>

            {/* Images */}
            <div className="form-group">
              <label>Images*</label>
              <input
                type="file"
                className="inputForm"
                name="images"
                onChange={handleImageChange}
                multiple
              />
              
              
              <div className="image-preview d-flex">
                {formData.images && formData.images.map((image, index) => (
                  <div key={index} className="image-container">
                    
                    <img
                      src={typeof image === 'string' ? image : URL.createObjectURL(image)}
                      alt={`Product ${index}`}
                      style={{ width: '100px', margin: '10px' }}
                    />
                    <button type="button" className="remove-button" onClick={() => handleImageRemove(index)}>
                        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"></path></svg>
                    </button>
                  </div>
                ))}
              </div>
            </div>

            {/* Quantity */}
            <div className="form-group">
              <label>Quantity*</label>
              <input
                type="number"
                className="inputForm"
                name="quantity"
                value={formData.quantity}
                onChange={handleChange}
                required
                placeholder="Enter quantity"
              />
            </div>

            {/* Type */}
            <div className="form-group">
              <label>Type*</label>
              <select
                name="type"
                value={formData.type}
                onChange={handleChange}
                className="inputForm"
                required
              >
                <option value="">Select Type</option>
                <option value="buy_now">Buy Now</option>
                <option value="pre_order">Pre Order</option>
              </select>
            </div>


            {/* Model Name */}
            <div className="form-group">
              <label>Model Name</label>
              <input
                type="text"
                className="inputForm"
                name="modelName"
                value={formData.modelName}
                onChange={handleChange}
                placeholder="Enter model name"
              />
            </div>

            {/* Model Height */}
            <div className="form-group">
              <label>Model Height</label>
              <input
                type="text"
                className="inputForm"
                name="modelHeight"
                value={formData.modelHeight}
                onChange={handleChange}
                placeholder="Enter model height"
              />
            </div>

            {/* Chest */}
            <div className="form-group">
              <label>Chest</label>
              <input
                type="text"
                className="inputForm"
                name="chest"
                value={formData.chest}
                onChange={handleChange}
                placeholder="Enter chest measurement"
              />
            </div>

            {/* Waist */}
            <div className="form-group">
              <label>Waist</label>
              <input
                type="text"
                className="inputForm"
                name="waist"
                value={formData.waist}
                onChange={handleChange}
                placeholder="Enter waist measurement"
              />
            </div>

            {/* Materials */}
            <div className="form-group">
              <label>Materials*</label>
              {formData.materials.map((material, index) => (
                <div key={index} className="d-flex mb-2">
                  <input
                    type="text"
                    className="inputForm"
                    value={material}
                    onChange={(e) => handleMaterialChange(e, index)}
                    required
                    placeholder="Enter material"
                  />
                  <div className="d-flex justify-content-between">
                    <button type="button" onClick={() => removeMaterial(index)} className="red-button mx-2">
                      <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1.2em" width="1.2em" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 5.5A.5.5 0 016 6v6a.5.5 0 01-1 0V6a.5.5 0 01.5-.5zm2.5 0a.5.5 0 01.5.5v6a.5.5 0 01-1 0V6a.5.5 0 01.5-.5zm3 .5a.5.5 0 00-1 0v6a.5.5 0 001 0V6z"></path><path fill-rule="evenodd" d="M14.5 3a1 1 0 01-1 1H13v9a2 2 0 01-2 2H5a2 2 0 01-2-2V4h-.5a1 1 0 01-1-1V2a1 1 0 011-1H6a1 1 0 011-1h2a1 1 0 011 1h3.5a1 1 0 011 1v1zM4.118 4L4 4.059V13a1 1 0 001 1h6a1 1 0 001-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" clip-rule="evenodd"></path></svg>
                    </button>
                    <button type="button" onClick={addMaterial} className="black-button mx-2">
                      <svg stroke="currentColor" fill="currentColor" stroke-width="0" t="1551322312294" viewBox="0 0 1024 1024" version="1.1" pId="10297" height="1.2em" width="1.2em" xmlns="http://www.w3.org/2000/svg"><defs></defs><path d="M474 152m8 0l60 0q8 0 8 8l0 704q0 8-8 8l-60 0q-8 0-8-8l0-704q0-8 8-8Z" pId="10298"></path><path d="M168 474m8 0l672 0q8 0 8 8l0 60q0 8-8 8l-672 0q-8 0-8-8l0-60q0-8 8-8Z" pId="10299"></path></svg>
                    </button>
                  </div>
                </div>
              ))}
             
            </div>

            

            {/* Submit Button */}
            <button type="submit" className="black-button">Edit Product</button>
          </form>
        </div>
      </Layout>
    </>
  );
};

export default EditProduct;
